export default __webpack_public_path__ + "assets/capture-2.de64e551.png";